/**
 * Notification Preferences API
 */

import apiClient from './client';

/**
 * Get current user's notification preferences
 */
export const getNotificationPreferences = async () => {
  const response = await apiClient.get('/api/v1/notifications/preferences');
  return response.data;
};

/**
 * Update notification preferences
 * @param {Object} preferences - Preference updates
 */
export const updateNotificationPreferences = async (preferences) => {
  const response = await apiClient.put('/api/v1/notifications/preferences', preferences);
  return response.data;
};

/**
 * Reset notification preferences to defaults
 */
export const resetNotificationPreferences = async () => {
  const response = await apiClient.post('/api/v1/notifications/preferences/reset');
  return response.data;
};
